import React, { forwardRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";
import moment from "moment";
import _ from "lodash";
import { TemplateForNotifications } from "src/constant";
import { useNavigate } from "react-router-dom";

const RightSideBar = forwardRef(
  ({ changeData, RightSidebarOpenCloseFlag }, ref) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const state = useSelector((state) => state.dashboard);
    const depoData = useSelector((state) => state?.depotUsers?.depoData || []);
    const notifications = useSelector(
      (state) => state?.dashboard?.notificationData
    );

    const [notificationsArray, setNotificationsArray] = useState([]);
    const lookupValues = useSelector((state) => state.lookup);

    const [selected, setSelected] = useState(0);
    const [sidebarOpen, _sidebarOpen] = useState(true);
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));

    useEffect(() => {
      dispatch(getAllNofificationForDashboard());
    }, []);

    const setDataInState = () => {
      let result = notifications?.result || [];
      if (selected) {
        const filteredNofnArray = _.filter(
          result,
          (d1) => d1.DepotId === parseInt(selected)
        );
        setNotificationsArray([...filteredNofnArray]);
      } else {
        setNotificationsArray([...result]);
      }
    };

    useEffect(() => {
      const intervalId = setInterval(async () => {
        dispatch(getAllNofificationForDashboard());
      }, 20000);
      return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
      setDataInState();
    }, [notifications, selected]);

    const toggleSidebar = () => {
      _sidebarOpen(!sidebarOpen);
      changeData(!RightSidebarOpenCloseFlag);
    };

    let newData = depoData?.length > 0 ? depoData : [];
    let depoDatas = [{ name: "ALL", id: 0 }, ...newData];

    if (!sidebarOpen) {
      return (
        <div ref={ref} className="mt-3 d-flex justify-content-center">
          <span onClick={() => toggleSidebar()}>
            <i className="bi bi-bell-fill bell-icon"></i>
          </span>
        </div>
      );
    } else {
      return (
        <div ref={ref} style={{ display: sidebarOpen ? "block" : "none" }}>
          <div
            className="d-flex flex-row align-items-center justify-content-between"
            style={{ height: 50, backgroundColor: "#f2f4f8" }}
          >
            <span className="ms-3 nofn-title">ACTIVITY LOG</span>
            <span onClick={() => toggleSidebar()}>
              <i className="bi bi-bell-slash-fill bell-icon bell-icon-design"></i>
            </span>
          </div>
          <div className="main-nofn">
            <div className="all-depots-dropdown-div">
              {userDetails?.roles == "DepotManager" ? (
                ""
              ) : (
                <select
                  className="form-select rightsidebar-all-depots-dropdown"
                  aria-label="Default select example"
                  onChange={({ target }) => setSelected(parseInt(target.value))}
                  value={selected}
                >
                  {depoDatas.map((d, index) => {
                    return (
                      <option key={index} value={d.id}>
                        {d.name}
                      </option>
                    );
                  })}
                </select>
              )}
            </div>
            <div className="rightsidebar-nofn-ActivityLog">
              {notificationsArray &&
                notificationsArray[0] &&
                notificationsArray?.map((item, index) => {
                  let ItemObject;
                  ItemObject = { ...item };
                  if (ItemObject?.DeliveryOrderStatus) {
                    ItemObject.DeliveryOrderStatus = _.find(
                      lookupValues?.data,
                      (d) =>
                        d?.id === parseInt(ItemObject?.DeliveryOrderStatus) &&
                        d?.typeName === "DeliveryOrderStatus"
                    )?.name;
                  }
                  return (
                    <div key={index} className="rightsidebar-nofn-content">
                      <p className="time-shown mb-2">
                        {moment(ItemObject.TimeStamp).format(
                          "DD-MMM-YYYY, HH:mm"
                        )}
                      </p>
                      {TemplateForNotifications(ItemObject, navigate)}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      );
    }
  }
);

export default RightSideBar;
